export const FIND_ROUTINE_ASSIGNMENTS = `
  query FindRoutineAssignments($routineId: String!) {
    routine {
      findRoutineAssignments(routineId: $routineId) {
        assets
      }
    }
  }
`;
